import React from "react";
import { motion } from "framer-motion";
import { Lightbulb, Volume2, Layers, Wand2, Package } from "lucide-react";

const ITEMS = [
  {
    icon: Lightbulb,
    title: "Lichttechnik",
    blurb: "Vom dezenten Ambiente bis zur großen Show – Lichttechnik, die bei jedem Event Eindruck hinterlässt.",
  },
  {
    icon: Volume2,
    title: "Tontechnik",
    blurb: "Druckvoller Sound, saubere Abstimmung – Events die nicht nur gut aussehen, sondern auch gut klingen.",
  },
  {
    icon: Layers,
    title: "Bühnenbau",
    blurb: "Von der kleinen Bühne bis zur großen Open-Air-Fläche – wir schaffen die passende Grundlage für euch.",
  },
  {
    icon: Wand2,
    title: "Konzeption",
    blurb: "Die Idee liegt bei euch – Planung, Technik und eine reibungslose Umsetzung bis ins Detail bei uns.",
  },
  {
    icon: Package,
    title: "Dry Hire",
    blurb: "Nur die Technik? Flexibel mieten – ohne großes Booking, unkompliziert und sofort einsatzbereit.",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      data-glow="services"
      className="relative z-10 px-6 sm:px-10 lg:px-20 py-28 lg:py-36 max-w-[1500px] mx-auto"
    >
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-14">
        <p className="eyebrow" style={{ fontSize: "clamp(13px, 1.1vw, 18px)" }}>
          01 — Was wir machen
        </p>
        <p className="body-mute max-w-md text-sm sm:text-base">
          Jedes Gewerk eigen, alle gemeinsam denkbar. Wir liefern entweder
          einzeln — oder das ganze Bild.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 lg:gap-5">
        {ITEMS.map((it, i) => (
          <motion.div
            key={it.title}
            className="svc-card"
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
            data-testid={`service-card-${it.title.toLowerCase()}`}
          >
            <div className="relative">
              <div className="flex items-center justify-between mb-10">
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-mute">
                  0{i + 1}
                </span>
                <it.icon size={18} className="text-amber" strokeWidth={1.4} />
              </div>
              <h3 className="h3-display mb-3">{it.title}</h3>
              <p className="text-sm body-mute leading-relaxed">{it.blurb}</p>
              <div
                className="mt-8 h-px w-full"
                style={{
                  background:
                    "linear-gradient(to right, rgba(244,152,0,0.3), transparent)",
                }}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
